var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg9D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7792 8.852C17.8279 8.852 18.7666 9.09767 19.5952 9.589C20.4312 10.0803 21.0912 10.766 21.5752 11.646C22.0592 12.5187 22.3012 13.5307 22.3012 14.682V19.28C22.3012 20.5267 22.0592 21.6047 21.5752 22.514C21.0912 23.416 20.4092 24.1127 19.5292 24.604C18.6492 25.088 17.6152 25.33 16.4272 25.33C15.6572 25.33 14.9239 25.2163 14.2272 24.989C13.5379 24.7543 12.8999 24.3693 12.3132 23.834L14.4472 21.7C14.7112 21.964 15.0156 22.1693 15.3602 22.316C15.7122 22.4627 16.0679 22.536 16.4272 22.536C16.9992 22.536 17.4942 22.404 17.9122 22.14C18.3376 21.8687 18.6639 21.5203 18.8912 21.095C19.1259 20.6623 19.2432 20.204 19.2432 19.72V17.366L19.7492 17.916C19.3019 18.378 18.7776 18.7337 18.1762 18.983C17.5749 19.225 16.9552 19.346 16.3172 19.346C15.3199 19.346 14.4399 19.1223 13.6772 18.675C12.9219 18.2277 12.3279 17.6153 11.8952 16.838C11.4699 16.0607 11.2572 15.1733 11.2572 14.176C11.2572 13.1787 11.5102 12.2803 12.0162 11.481C12.5222 10.6743 13.1932 10.0363 14.0292 9.567C14.8652 9.09033 15.7819 8.852 16.7792 8.852ZM16.7792 11.712C16.3246 11.712 15.9066 11.822 15.5252 12.042C15.1512 12.262 14.8506 12.559 14.6232 12.933C14.4032 13.307 14.2932 13.7213 14.2932 14.176C14.2932 14.6307 14.4032 15.0487 14.6232 15.43C14.8432 15.804 15.1402 16.1047 15.5142 16.332C15.8882 16.552 16.3026 16.662 16.7572 16.662C17.2119 16.662 17.6262 16.552 18.0002 16.332C18.3816 16.1047 18.6822 15.804 18.9022 15.43C19.1296 15.0487 19.2432 14.6307 19.2432 14.176C19.2432 13.736 19.1332 13.329 18.9132 12.955C18.6932 12.581 18.3962 12.2803 18.0222 12.053C17.6482 11.8257 17.2339 11.712 16.7792 11.712Z",
    fill: "#2B65CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "#2B65CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "#2B65CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9D);
export default __webpack_public_path__ + "static/media/9d.b374ab545a632a358dd08aaacb683e4a.svg";
export { ForwardRef as ReactComponent };